import React from 'react'
import { List } from 'semantic-ui-react'
import moment from 'moment'
import PropTypes from "prop-types";
import { EntityTypes } from '../shared/constants';
import { useTextResources } from '../../language';

const fmt = "MM/YYYY"
const CardList = ({ items, authorization, onSelect, onSelectItem, selected }) => {
    const text = useTextResources()
    return <List divided relaxed selection={(onSelect || onSelectItem) ? true : false} onItemClick={(e, item) => {
        if (onSelect) {
            onSelect(item.id)
        }
        if (onSelectItem) {
            onSelectItem(items.find(x => x.Id === item.id))
        }
    }} items={
        items.map(item => {
            return {
                key: item.Id,
                id: item.Id,
                active: item.PaymentTokenId === selected || item.Id === selected,
                className: "card-item",
                icon: "credit card",
                header: `${item.CardCompanyName} for ${text(EntityTypes[item.EntityTypeID])}`,
                description: <table>
                    <tbody>
                        <tr>
                            <td>{text("CardNumber")}:</td>
                            <td>{`**** **** **** ${item.LastFourDigits}`}</td>
                            <td></td>
                            <td rowSpan="2"><b>{item.CompanyPaymentName}</b></td>
                        </tr>
                        <tr>
                            <td>{text("Expiry")}:</td>
                            <td>{`${moment(item.CreditCardExpirationDate).format(fmt)}`}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>,
                content: authorization ? `Authorization amount: ${item.Amount},  Used: ${item.UsedAmount || 0}` : null
            }
        })
    }
    />
}
CardList.propTypes = {
    items: PropTypes.array,
    authorization: PropTypes.bool,
    onSelect: PropTypes.func,
    selected: PropTypes.number,
    onSelectItem: PropTypes.func
}
export default CardList